'use strict';
if (!RedactorPlugins) var RedactorPlugins = {};

RedactorPlugins.fontfamily = function () {
    var c = 0,
        dropdown = {},
        addSeparator = function (text) {
            c++;
            dropdown['s' + c] = {
                "title": text,
                "data": {
                    "classes": "separator",
                    "family": "sans serif"
                }
            };
        },
        fillDropdown = function (fonts, classes) {
            for (var i = 0, l = fonts.length; i < l; i++) {
                var font = fonts[i],
                    id = "id-" + font.id;
                dropdown[id + " ajax-tooltip"] = {
                    "title": '<img src="' + Fotobook.createStorageUrl(font.preview_path).escapeAttr() + '" alt="' + font.name.escapeAttr() + '">',
                    "data": {
                        "id": font.id,
                        "classes": classes,
                        "qtip-text": font.name,
                    },
                    "func": function (btn) {
                        const fontId = dropdown[btn].data.id;
                        const font = Fotobook.store.getters['Fonts/getFontById'](fontId);

                        if (font) {
                            Fotobook.store.commit('Fonts/loadFontById', font.id);
                            this.fontfamily.set(font.family);
                        }
                    },
                };
            }
        };

    return {
        init: function () {
            //рисуем сначала шрифты темы
            if (Fotobook.book.fonts.length) {
                fillDropdown(Fotobook.book.fonts, 'default-font');
            }
            //рисуем шрифты из других тем

            const externalFonts = Fotobook.store.getters['Fonts/getExternalFonts'];
            if (externalFonts.length) {
                addSeparator(t("photobook-js-fonts-from-external-themes"));
                fillDropdown(externalFonts, 'external-font');
            }

            var button = this.button.add('fontfamily', this.lang.get('fontfamily'));
            this.button.addDropdown(button, dropdown);

        },
        set(fontFamily) {
            let font = Fotobook.store.getters['Fonts/getFontByFamily'](fontFamily);
            if (font) {
                let validator = Fotobook.textValidator;
                let node = document.createTextNode(this.selection.getText());
                let deleted = Object.keys(validator.validateText(node, font));

                if (deleted.length) {
                    validator.showDeletedSymbolsConfirm(deleted).then(() => {
                        this.inline.format("span", "style", "font-family:" + font.family + ";");
                    }).catch(()=>{});
                } else {
                    this.inline.format("span", "style", "font-family:" + font.family + ";");
                }
                validator.validate(this.$editor);
            }
            // необходимо выполнить через setTimeout, так как обработчик done может выполняться внутри
            // другого события (click либо keypress) и в этом случае фокус будет перехвачен событием
            // todo: рассмоьтреть возможность перенести в textValidator
            setTimeout(() => this.$editor.focus(), 0);
        },

        reset: function () {
            this.inline.removeStyleRule('font-family');
        },
    };
};

